import { isValid } from 'clients/Clients';
import { getVoucherDetail } from 'clients/PromoClient';
import { useEffect, useState } from 'react';
import { BeVoucher } from 'types/voucher';
import { useDebounce } from 'utils/debounce';
import useCartStates from 'zustand-lib/useCart';

export const useGetVoucherInfo = (code: string) => {
  const { cartData } = useCartStates();

  const [refetch, setFefetch] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [voucherInfo, setVoucherInfo] = useState<BeVoucher>();

  const refetchVoucherInfo = () => setFefetch((prev) => !prev);

  const cartDebounce = useDebounce(cartData, 2000);

  const fetchData = () => {
    if (!code) return;

    getVoucherDetail({ codes: [code] })
      .then((res) => {
        if (isValid(res)) {
          const data = res.data[0];
          setVoucherInfo(data);
        }
      })
      .finally(() => {
        setIsLoading(false);
        setIsStatusLoading(false);
      });
  };

  useEffect(() => {
    setIsStatusLoading(true);
  }, [cartData]);

  useEffect(() => {
    fetchData();
  }, [refetch, cartDebounce]);

  return {
    isLoading,
    voucherInfo,
    isStatusLoading,
    refetchVoucherInfo,
  };
};

